export default {
  getJoinCount: process.env.BASE_URL + '/api/modules/lighten/get_join_count',
  getStarList: process.env.BASE_URL + '/api/modules/lighten/friend_list',
  starSelf: process.env.BASE_URL + '/api/modules/lighten/click',
  star: process.env.BASE_URL + '/api/modules/lighten/help',
  signUp: process.env.BASE_URL + '/api/modules/lighten/submit'
}